module.exports = __webpack_public_path__ + "img/phoneTop.1d70792f.png";